import { render, staticRenderFns } from "./AiDashboard.vue?vue&type=template&id=35bb3420&scoped=true"
import script from "./AiDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./AiDashboard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AiDashboard.vue?vue&type=style&index=0&id=35bb3420&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bb3420",
  null
  
)

export default component.exports